// @flow
import { Wrapper } from "./icons.styles";
import Icon, { Icons } from "react-hp-icons";
import React from "react";
import type { InlineProps } from "./types";

const InlineReservable = ({ size, color }: InlineProps) => (
	<Wrapper size={size} color={color} inline>
		<Icon type={Icons.calendar} size={size + 0.5} color={color} />
		<span>Reservable</span>
	</Wrapper>
);

export default InlineReservable;
